// The main detection function was adapted from work of Dhanil here:
// https://stackoverflow.com/questions/49686741/detect-unsupported-browser-version-and-show-specific-div-with-message
// and later modifications by Andreas Remdt posted here:
// digitalminds.io/blog/detecting-outdated-browsers-in-vanilla-javascript

/**
 * Returns an object representing the user's browser with name and version properties.
 */
export const browserId = () => {
    const userAgent = navigator.userAgent

    const agentNameMatches =
        userAgent.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
        ) || []

    // Check for newer IE and return info
    if (/trident/i.test(agentNameMatches[1])) {
        const ieVersions = /\brv[ :]+(\d+)/g.exec(userAgent) || []
        return { name: 'IE', version: ieVersions[1] || '' }
    }

    // Check for Opera and Edge and return info
    if (agentNameMatches[1] === 'Chrome') {
        const operaOrEdgeInfo = userAgent.match(/\b(OPR|Edge|Edg)\/(\d+)/)
        if (operaOrEdgeInfo != null) {
            if (operaOrEdgeInfo[1] === 'Edge') {
                const engineVersion = operaOrEdgeInfo[2]
                // Not accurate below engine version 15, but that's too old anyway.
                const version =
                    engineVersion === '18'
                        ? '44'
                        : (parseInt(engineVersion, 10) + 25).toString()
                return {
                    name: operaOrEdgeInfo[1],
                    version: version,
                }
            }
            return {
                name: operaOrEdgeInfo[1]
                    .replace('OPR', 'Opera')
                    .replace('Edg', 'Edge'),
                version: operaOrEdgeInfo[2],
            }
        }
    }

    // Return info for everything else
    const otherBrowser = agentNameMatches[2]
        ? [agentNameMatches[1], agentNameMatches[2]]
        : [navigator.appName, navigator.appVersion, '-?']
    let otherBrowserInfo
    if ((otherBrowserInfo = userAgent.match(/version\/(\d+)/i)) != null)
        otherBrowser.splice(1, 1, otherBrowserInfo[1])
    return { name: otherBrowser[0], version: otherBrowser[1] }
}
